import type { Post } from '@lib/schemas/post';
import { fetchGhostPosts } from '@lib/adapters/ghost';
import { useAsync, type AsyncState } from './useAsync';

export function useGhostPosts(limit = 6): AsyncState<Post[]> {
  return useAsync<Post[]>((signal) => fetchGhostPosts({ limit, signal }), [limit]);
}
